import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { tagebuchExtra, type TagebuchExtra } from '@symphenia/shared-types'
import type { ErpEinstellungenProps } from '../registry'

/**
 * AP-48 7. — **Einstellungen des Bautagesberichts**: Namen der Belegschaft im Bericht zeigen (TB-5, Vorgabe
 * aus). Der Schalter speichert sofort — über die Speicherstelle der Einstellungen (`speichere`).
 */
export function TagebuchEinstellungen({ extra, speichere }: ErpEinstellungenProps) {
  const { t } = useTranslation()
  const [stand, setStand] = useState<TagebuchExtra>(() => tagebuchExtra(extra))
  return (
    <div className="space-y-1 border-t pt-3">
      <label className="flex items-start gap-3 text-sm">
        <input
          type="checkbox"
          className="mt-0.5 h-4 w-4"
          checked={stand.namenZeigen}
          onChange={(e) => {
            const neu = { ...stand, namenZeigen: e.target.checked }
            setStand(neu)
            void speichere(neu as unknown as Record<string, unknown>)
          }}
        />
        <span>
          <span className="font-medium">{t('siteDocs.diary.settingsNames')}</span>
          <span className="mt-0.5 block text-xs text-muted-foreground">{t('siteDocs.diary.settingsNamesHint')}</span>
        </span>
      </label>
    </div>
  )
}
